import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum AuditFields {
	companyserviceSiteId = 'companyserviceSiteId',
	kpiName = 'kpiName',
	locationName = 'locationName',
	category = 'category',
	measureValue = 'measureValue',
	previousMeasureValue = 'previousMeasureValue',
	isExceed = 'isExceed',
	uomCode = 'uomCode',
	year = 'year',
	percentChange = 'percentChange',
	termCode = 'termCode',
	exportCode = 'exportCode',
	createDate = 'createDate',
	lastUpdateDate = 'lastUpdateDate',
	date = 'date',
	updatedByAuthor = 'updatedByAuthor',
	createdByAuthor = 'createdByAuthor',
	serviceSiteId = 'serviceSiteId'
}

export enum AuditMainSearchFields {
	serviceSiteId = 'searchLocationById',
	locationName = 'searchLocationByName',
	createdUser = 'searchCreatedUserByName',
	updatedUser = 'searchUpdatedUserByName'
}

export enum AuditFilterFields {
	createFrom = 'createdFrom',
	createTo = 'createdTo',
	updateFrom = 'updatedFrom',
	updateTo = 'updatedTo',
	isUpdatedOnly = 'updatedOnly',
	isExceedThreshold = 'exceedThreshold',
	KpiCategoryCode = 'KpiCategoryCode',
	kpiId = 'kpiId'
}

export declare namespace Audit {
	interface Author {
		id: number
		firstName: string
		lastName: string
	}
	interface Basic {
		[AuditFields.companyserviceSiteId]: number
		[AuditFields.kpiName]: BasicString
		[AuditFields.locationName]: BasicString
		[AuditFields.category]: BasicString
		[AuditFields.measureValue]: BasicString
		[AuditFields.previousMeasureValue]: BasicString
		[AuditFields.isExceed]: boolean
		[AuditFields.uomCode]: BasicString
		[AuditFields.year]: number
		[AuditFields.percentChange]: number
		[AuditFields.termCode]: BasicString
		[AuditFields.exportCode]: BasicString
		[AuditFields.createDate]: BasicString
		[AuditFields.lastUpdateDate]: BasicString
		[AuditFields.updatedByAuthor]: Author
		[AuditFields.createdByAuthor]: Author
		[AuditFields.serviceSiteId]: BasicNumber
	}

	namespace Search {
		interface CompanyLocationEntity extends Entity {
			companyserviceSiteId: number
		}

		interface EntityWithUser extends Entity {
			userId: number
		}

		interface Config {
			[AuditMainSearchFields.serviceSiteId]: ConfigItem<AuditMainSearchFields>
			[AuditMainSearchFields.locationName]: ConfigItem<AuditMainSearchFields>
			[AuditMainSearchFields.createdUser]: ConfigItem<AuditMainSearchFields, EntityWithUser>
			[AuditMainSearchFields.updatedUser]: ConfigItem<AuditMainSearchFields, EntityWithUser>
		}

		interface Result {
			[AuditMainSearchFields.serviceSiteId]: CompanyLocationEntity[]
			[AuditMainSearchFields.locationName]: CompanyLocationEntity[]
			[AuditMainSearchFields.createdUser]: EntityWithUser[]
			[AuditMainSearchFields.updatedUser]: EntityWithUser[]
		}
	}

	namespace Filter {
		interface Config {
			[AuditFilterFields.createFrom]: ConfigFilterItem<string, null>
			[AuditFilterFields.createTo]: ConfigFilterItem<string, null>
			[AuditFilterFields.updateFrom]: ConfigFilterItem<string, null>
			[AuditFilterFields.updateTo]: ConfigFilterItem<string, null>
			[AuditFilterFields.isUpdatedOnly]: ConfigFilterItem<string, boolean>
			[AuditFilterFields.isExceedThreshold]: ConfigFilterItem<string, boolean>
			[AuditFilterFields.kpiId]: ConfigFilterItem<string, null>
			[AuditFilterFields.KpiCategoryCode]: ConfigFilterItem<string, null>
		}
	}

	interface Daily {
		id: string
		[AuditFields.companyserviceSiteId]: number
		[AuditFields.kpiName]: string
		[AuditFields.locationName]: string
		[AuditFields.measureValue]: string
		[AuditFields.uomCode]: string
		[AuditFields.year]: number
		[AuditFields.termCode]: string
		[AuditFields.date]: string
	}
}
